<template>
    <!-- Product Permission For Employees -->
    <div class="tabs-content-firstblock" style="max-height: 78.2em; overflow-y: auto; overflow-x: hidden;">
        <div class="row" v-if="requestResponse">
            <div class="col-lg-12 py-5 px-3 mt-10">
                <div class="flex-container">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-12 pr-0 pl-0">
                <div class="productspageHeader">
                    <div class="descriptionheader">
                        <div class="description-text-header-left">
                            <h5>
                                Products Subscribed
                            </h5>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="ajaxCallinprogress">
                    <div class="col-lg-12 py-5 px-3 mt-10">
                        <div class="flex-container">
                            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                        </div>
                    </div>
                </div>
                <div class="row" v-if="!ajaxCallinprogress && !productsenabled.length">
                    <div class="col-lg-12 text-center py-3 px-3 mt-10">
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/no_products_found.svg"
                            class="img-fluid" style="width: 150px;">
                        <h5 class="pt-3" style="color: #00448b;">No Subscribed Products Found</h5>
                    </div>
                </div>
                <div v-else class="mt-5">
                    <div
                        class="products-section prodadmin-uk-grid-width-small-1-2 prodadmin-uk-grid-width-medium-1-47 prodadmin-uk-grid-width-large-1-47 prodadmin-uk-grid-width-xlarge-1-31">
                        <div class="card-box products-box" v-for="(product,index) in productsenabled" :key="index">
                            <div class="md-card adminproducts-card md-card-hover">
                                <div class="md-card-head">
                                    <div class="panel panel-body panel-prod prod-h">
                                        <div class="" @click="openPage(product.public_url)"
                                            style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;overflow: hidden;cursor:pointer;">
                                        </div>
                                        <div class="mediaprodadmin">
                                            <div class="media-left">
                                                <a :href="product.public_url" target="_blank">
                                                    <img :src="product.logo">
                                                </a>
                                            </div>
                                            <div class="media-body" @click="openPage(product.public_url)"
                                                style="cursor:pointer;">
                                                <el-tooltip class="item" effect="dark" :content="product.product_name"
                                                    placement="top">
                                                    <h6 class="media-heading prodadmin-uk-text-truncate">
                                                        {{product.product_name}}
                                                    </h6>
                                                </el-tooltip>
                                                <p class="prodadmin-uk-text-truncate textwhite">
                                                    <span v-if="product.access_level">{{product.access_level}}</span>
                                                </p>
                                            </div>
                                            <div class="media-right media-middle"
                                                v-if="businessData._id==$route.params.id && (admin || superAdmin)">
                                                <el-dropdown trigger="click">
                                                    <span class="el-dropdown-link">
                                                        <i class="icon-dots-vertical"
                                                            @click="getPermissions(product)"></i>
                                                    </span>
                                                    <el-dropdown-menu slot="dropdown"
                                                        style="max-height: 11em; overflow-x: hidden; overflow-y: auto;">
                                                        <el-dropdown-item v-for="(perms,index) in permissions"
                                                            :key="index"
                                                            @click.native="productPermission(perms.value, product._id)">
                                                            {{perms.name}}</el-dropdown-item>
                                                        <el-dropdown-item @click.native="productDisable(product._id)">
                                                            Remove</el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="productspageHeader" v-if="businessData._id==$route.params.id && (admin || superAdmin)">
                    <div class="descriptionheader">
                        <div class="description-text-header-left">
                            <h5>
                                Products not Subscribed
                            </h5>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="ajaxCallinprogress">
                    <div class="col-lg-12 py-5 px-3 mt-10">
                        <div class="flex-container">
                            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                        </div>
                    </div>
                </div>
                <div class="row" v-if="!ajaxCallinprogress && !productsdisabled.length">
                    <div class="col-lg-12 text-center py-3 px-3 mt-10">
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/no_products_found.svg"
                            class="img-fluid" style="width: 150px;">
                        <h5 class="pt-3" style="color: #00448b;">No Products Found</h5>
                    </div>
                </div>
                <div class="mt-5" v-else>
                    <div v-if="businessData._id==$route.params.id && (admin || superAdmin)"
                        class="products-section prodadmin-uk-grid-width-small-1-2 prodadmin-uk-grid-width-medium-1-47 prodadmin-uk-grid-width-large-1-47 prodadmin-uk-grid-width-xlarge-1-31">
                        <div class="card-box products-box" v-for="(product,index) in productsdisabled" :key="index">
                            <div class="md-card adminproducts-card md-card-hover">
                                <div class="md-card-head">
                                    <div class="panel panel-body panel-prod prod-h">
                                        <div class="mediaprodadmin">
                                            <div class="media-left">
                                                <a href="javascript:;">
                                                    <img :src="product.logo">
                                                </a>
                                            </div>
                                            <div class="media-body">
                                                <el-tooltip class="item" effect="dark" :content="product.product_name"
                                                    placement="top">
                                                    <h6 class="media-heading prodadmin-uk-text-truncate">
                                                        {{product.product_name}}
                                                    </h6>
                                                </el-tooltip>
                                                <span v-if="product.description">
                                                    <el-tooltip class="item" effect="dark"
                                                        :content="product.description" placement="top">
                                                        <p class="prodadmin-uk-text-truncate">{{product.description}}
                                                        </p>
                                                    </el-tooltip>
                                                </span>
                                                <span v-else>
                                                    <p class="prodadmin-uk-text-truncate">-</p>
                                                </span>
                                            </div>
                                            <div class="media-right media-middle">
                                                <el-dropdown trigger="click">
                                                    <span class="el-dropdown-link">
                                                        <i class="icon-dots-vertical"
                                                            @click="getPermissions(product)"></i>
                                                    </span>
                                                    <el-dropdown-menu slot="dropdown"
                                                        style="max-height: 11em; overflow-x: hidden; overflow-y: auto;">
                                                        <el-dropdown-item v-for="(perms,index) in permissions"
                                                            :key="index"
                                                            @click.native="productPermissionEnable(perms.value, product._id)">
                                                            {{perms.name}}</el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    import {
        HalfCircleSpinner
    } from 'epic-spinners';
    export default {
        data() {
            return {
                productsenabled: [],
                productsdisabled: [],
                userProducts: [],
                selected_products: {},
                permission_dict: {},
                initial_product_ids: [],
                employee_products: {},
                access_given: {},
                update_access: {},
                remove_access: {},
                ajaxCallinprogress: false,
                requestResponse: false,
                employeeInfo: {},
                userProductsOptions: [],
                permissions: []
            };
        },
        components: {
            HalfCircleSpinner
        },
        props: ["businessData"],
        methods: {
            openPage(url) {
                window.open(url, "new_window");
            },

            // Get Products For Employee
            getProducts() {
                this.ajaxCallinprogress = true;
                this.productsenabled = []
                this.productsdisabled = []
                if (this.account) {
                    this.$http
                        .post("/employees/get_products_employee", {
                            employee_id: this.businessData._id,
                            company_id: this.$route.params.company_id
                        })
                        .then(res => {
                            if (res.data.status_id == 1) {
                                this.productsenabled = res.data.response.products_enabled;
                                this.productsdisabled = res.data.response.products_not_enabled;
                                this.ajaxCallinprogress = false;
                            }
                        });
                }
            },

            // Product Access Level Function
            productPermission(accesslevel, product_id) {
                this.requestResponse = true;
                this.$http
                    .post("/employees/change_product_access_level", {
                        product_id: product_id,
                        access_level: accesslevel,
                        employee_id: this.employeeInfo._id
                    })
                    .then(res => {
                        if (res.data.status_id == 1) {
                            this.getProducts()
                            this.$swal({
                                title: "Employee Role",
                                text: "Product Access Changed Successfully",
                                type: "success",
                                confirmButtonText: "OK",
                                confirmButtonColor: "#005dae",
                            });
                        } else {
                            this.getProducts()
                            this.$swal({
                                title: "Error",
                                text: "Product Access Change Failed. Please Try Again",
                                type: "error",
                                confirmButtonText: "OK",
                                confirmButtonColor: "#005dae",
                            });
                        }
                        this.requestResponse = false;
                    });
            },

            // Product Access Enable
            productPermissionEnable(accesslevel, product_id) {
                this.requestResponse = true;
                this.$http
                    .post("/employees/enable_product_access", {
                        product_id: product_id,
                        access_level: accesslevel,
                        employee_id: this.employeeInfo._id
                    })
                    .then(res => {
                        if (res.data.status_id == 1) {
                            this.getProducts()
                            this.$swal({
                                title: "Employee Role",
                                text: "Product Access Changed Successfully",
                                type: "success",
                                confirmButtonText: "OK",
                                confirmButtonColor: "#005dae",
                            });
                        } else {
                            this.getProducts()
                            this.$swal({
                                title: "Error",
                                text: "Product Access Change Failed. Please Try Again",
                                type: "error",
                                confirmButtonText: "OK",
                                confirmButtonColor: "#005dae",
                            });
                        }
                        this.requestResponse = false;
                    });
            },

            // Product Permission Remove Function
            productDisable(product_id) {
                this.requestResponse = true;
                this.$http
                    .post("/employees/disable_product", {
                        product_id: product_id,
                        employee_id: this.employeeInfo._id
                    })
                    .then(res => {
                        if (res.data.status_id == 1) {
                            this.getProducts()
                            this.$swal({
                                title: "Employee Subscription",
                                text: "Removed Successfully",
                                type: "success",
                                confirmButtonText: "OK",
                                confirmButtonColor: "#005dae",
                            });
                        } else {
                            this.getProducts()
                            this.$swal({
                                title: "Error",
                                text: "Please Try Again",
                                type: "error",
                                confirmButtonText: "OK",
                                confirmButtonColor: "#005dae",
                            });
                        }
                        this.requestResponse = false;
                    });
            },

            // Giving Permission In Purchased Products
            purchaseProducts(accesslevel, product_id) {
                this.requestResponse = true;
                this.$http
                    .post("/employees/enable_product_access", {
                        product_id: product_id,
                        access_level: accesslevel,
                        employee_id: this.employeeInfo._id
                    })
                    .then(res => {
                        if (res.data.status_id == 1) {
                            this.getProducts()
                            this.$swal({
                                title: "Employee Subscription",
                                text: "Employee Subscribed Successfully",
                                type: "success",
                                confirmButtonText: "OK",
                                confirmButtonColor: "#005dae",
                            });
                        } else {
                            this.getProducts()
                            this.$swal({
                                title: "Error",
                                text: "Subscription Failed. Please Try Again",
                                type: "error",
                                confirmButtonText: "OK",
                                confirmButtonColor: "#005dae",
                            });
                        }
                        this.requestResponse = false;
                    });
            },

            // Getting Employee Data and Permissions
            getEmployeeData() {
                this.$http
                    .post("employees/get_employee_data", {
                        emp_id: this.$route.params.id
                    })
                    .then(response => {
                        if (response.data.status_id == 1) {
                            this.employeeInfo = response.data.response;
                            // this.setInitialProducts()
                        }
                    })
                    .catch(error => {
                    });
            },
            // Getting Permissions
            getPermissions(product) {
                let params = {
                    search_key: "",
                    product_id: product._id,
                    skip: 0,
                    limit: 100
                }
                this.$http.post('/digi_products/get_role', params)
                    .then(res => {
                        if (res.data.status_id == 1) {
                            this.permissions = []
                            this.permissions = res.data.response
                        }
                    })
            },
            // setInitialProducts(){
            //   this.products.forEach(pr =>{
            //     this.employeeInfo.products.forEach(product =>{
            //       if(pr._id ==product.product){
            //         this.initial_product_ids.push(pr._id)
            //         this.userProducts.push(product)
            //         this.selected_products[pr._id] = {
            //             has_access : true,
            //             access_level : product.access_level,
            //           }
            //         if(product.has_access){
            //           this.employee_products[pr._id] = {
            //             has_access : product.has_access,
            //             access_level : product.access_level,
            //           }
            //         }
            //       }
            //     })
            //   })
            // },
        },
        mounted() {
            this.getEmployeeData();
            this.getProducts();
        },
        computed: {
            account() {
                return this.$store.getters.account;
            },
            admin() {
                return this.$store.getters.isAdmin;
            },
            superAdmin() {
                return this.$store.getters.isSuperAdmin;
            },
        },
    };
</script>
<style>
    .panel.panel-prod {
        margin-bottom: 0px;
        background-color: transparent;
        border: 1px solid transparent;
        border-radius: 0px;
        -webkit-box-shadow: none;
        box-shadow: none;
        color: inherit;
        padding: 0.8rem 1.2rem;
        cursor: default;
    }

    .panel.panel-prod.prod-h {
        padding: 1.8rem 1.2rem;
    }

    .panel-body.panel-prod:before {
        content: " ";
        display: table;
    }

    .mediaprodadmin {
        margin-top: 0px;
        position: relative;
    }

    .mediaprodadmin,
    .mediaprodadmin .media-body {
        zoom: 1;
        overflow: visible;
    }

    .mediaprodadmin .media-body {
        display: table-cell;
        vertical-align: top;
        position: relative;
    }

    .mediaprodadmin .media-body.media-text-middle {
        display: table-cell;
        vertical-align: middle;
        position: relative;
    }

    .mediaprodadmin .media-left,
    .mediaprodadmin .media-right {
        display: table-cell;
        vertical-align: middle;
        position: relative;
    }

    .mediaprodadmin .media-left {
        padding-right: 20px;
        cursor: pointer;
    }

    .mediaprodadmin .media-left a {
        outline: 0;
        cursor: pointer;
        text-decoration: none;
        background-color: transparent;
    }

    .mediaprodadmin .media-left a img {
        width: 40px;
        height: 40px;
        max-height: 40px;
        max-width: 40px;
        line-height: 40px;
    }

    .mediaprodadmin .media-body {
        width: 10000px;
    }

    .mediaprodadmin .media-left a i {
        width: 40px !important;
        height: 40px !important;
        line-height: 40px !important;
        vertical-align: middle;
        color: #00448b;
        font-size: 40px;
    }

    .mediaprodadmin .media-left a i.logo-crm {
        font-size: 25px;
    }

    .mediaprodadmin .media-left a i.logo-pos {
        font-size: 30px;
    }

    .mediaprodadmin .media-left a i.logo-pay {
        font-size: 25px;
    }

    .mediaprodadmin .media-left a i.logo-cloud {
        font-size: 25px;
    }

    .mediaprodadmin .media-left a i.logo-play {
        font-size: 25px;
    }

    .mediaprodadmin .media-body h6.media-heading {
        margin-bottom: 2px;
        display: block;
        margin-top: 0;
        font-size: 15px;
        letter-spacing: -.015em;
        line-height: 1.5384616;
        color: #fff;
        width: 145px;
        font-weight: bold;
        cursor: pointer;
    }

    .mediaprodadmin .media-body p {
        margin: 0 0 10px;
        font-size: 14px;
        letter-spacing: 0.6px;
        margin: 1px 0 1px 0;
        color: #fff;
        width: 145px;
        height: 24px;
    }

    .mediaprodadmin .media-body p.textgreen {
        color: #1a9347;
        font-size: 13px;
        font-weight: 600;
    }

    .mediaprodadmin .media-body p.textwhite {
        color: #fff;
        font-size: 13px;
        font-weight: 600;
    }

    .mediaprodadmin .media-right {
        padding-left: 5px;
    }

    .media-middle {
        vertical-align: middle;
    }

    .prodadmin-uk-text-truncate {
        display: block;
    }

    .prodadmin-uk-text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .prodadmin-uk-grid {
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -ms-flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
        margin: 0;
        padding: 0;
        list-style: none
    }

    .prodadmin-uk-grid:after,
    .prodadmin-uk-grid:before {
        content: "";
        display: block;
        overflow: hidden
    }

    .prodadmin-uk-grid:after {
        clear: both
    }

    .prodadmin-uk-grid>* {
        -ms-flex: none;
        -webkit-flex: none;
        flex: none;
        margin: 0;
        float: left
    }

    .prodadmin-uk-grid>*>:last-child {
        margin-bottom: 0
    }

    .prodadmin-uk-grid {
        margin-left: -25px
    }

    .prodadmin-uk-grid>* {
        padding-left: 25px
    }

    .prodadmin-uk-grid+.prodadmin-uk-grid,
    .prodadmin-uk-grid-margin,
    .prodadmin-uk-grid>*>.prodadmin-uk-panel+.prodadmin-uk-panel {
        margin-top: 25px
    }

    @media (min-width:1220px) {
        .prodadmin-uk-grid {
            margin-left: -35px
        }

        .prodadmin-uk-grid>* {
            padding-left: 35px
        }

        .prodadmin-uk-grid+.prodadmin-uk-grid,
        .prodadmin-uk-grid-margin,
        .prodadmin-uk-grid>*>.prodadmin-uk-panel+.prodadmin-uk-panel {
            margin-top: 35px
        }
    }

    .prodadmin-uk-grid-collapse {
        margin-left: 0
    }

    .prodadmin-uk-grid-collapse>* {
        padding-left: 0
    }

    .prodadmin-uk-grid-collapse+.prodadmin-uk-grid-collapse,
    .prodadmin-uk-grid-collapse>*>.prodadmin-uk-panel+.prodadmin-uk-panel,
    .prodadmin-uk-grid-collapse>.prodadmin-uk-grid-margin {
        margin-top: 0
    }

    .prodadmin-uk-grid-small {
        margin-left: -10px
    }

    .prodadmin-uk-grid-small>* {
        padding-left: 10px
    }

    .prodadmin-uk-grid-small+.prodadmin-uk-grid-small,
    .prodadmin-uk-grid-small>*>.prodadmin-uk-panel+.prodadmin-uk-panel,
    .prodadmin-uk-grid-small>.prodadmin-uk-grid-margin {
        margin-top: 10px
    }

    .prodadmin-uk-grid-medium {
        margin-left: -25px
    }

    .prodadmin-uk-grid-medium>* {
        padding-left: 25px
    }

    .prodadmin-uk-grid-medium+.prodadmin-uk-grid-medium,
    .prodadmin-uk-grid-medium>*>.prodadmin-uk-panel+.prodadmin-uk-panel,
    .prodadmin-uk-grid-medium>.prodadmin-uk-grid-margin {
        margin-top: 25px
    }

    @media (min-width:960px) {
        .prodadmin-uk-grid-large {
            margin-left: -35px
        }

        .prodadmin-uk-grid-large>* {
            padding-left: 35px
        }

        .prodadmin-uk-grid-large+.prodadmin-uk-grid-large,
        .prodadmin-uk-grid-large-margin,
        .prodadmin-uk-grid-large>*>.prodadmin-uk-panel+.prodadmin-uk-panel {
            margin-top: 35px
        }
    }

    @media (min-width:1220px) {
        .prodadmin-uk-grid-large {
            margin-left: -50px
        }

        .prodadmin-uk-grid-large>* {
            padding-left: 50px
        }

        .prodadmin-uk-grid-large+.prodadmin-uk-grid-large,
        .prodadmin-uk-grid-large-margin,
        .prodadmin-uk-grid-large>*>.prodadmin-uk-panel+.prodadmin-uk-panel {
            margin-top: 50px
        }
    }

    .prodadmin-uk-grid-divider:not(:empty) {
        margin-left: -25px;
        margin-right: -25px
    }

    .prodadmin-uk-grid-divider>* {
        padding-left: 25px;
        padding-right: 25px
    }

    .prodadmin-uk-grid-divider>[class*=prodadmin-uk-width-9-]:nth-child(n+2),
    .prodadmin-uk-grid-divider>[class*=prodadmin-uk-width-1-]:not(.prodadmin-uk-width-1-1):nth-child(n+2),
    .prodadmin-uk-grid-divider>[class*=prodadmin-uk-width-2-]:nth-child(n+2),
    .prodadmin-uk-grid-divider>[class*=prodadmin-uk-width-3-]:nth-child(n+2),
    .prodadmin-uk-grid-divider>[class*=prodadmin-uk-width-4-]:nth-child(n+2),
    .prodadmin-uk-grid-divider>[class*=prodadmin-uk-width-5-]:nth-child(n+2),
    .prodadmin-uk-grid-divider>[class*=prodadmin-uk-width-6-]:nth-child(n+2),
    .prodadmin-uk-grid-divider>[class*=prodadmin-uk-width-7-]:nth-child(n+2),
    .prodadmin-uk-grid-divider>[class*=prodadmin-uk-width-8-]:nth-child(n+2) {
        border-left: 1px solid #ddd
    }

    @media (min-width:768px) {
        .prodadmin-uk-grid-divider>[class*=prodadmin-uk-width-medium-]:not(.prodadmin-uk-width-medium-1-1):nth-child(n+2) {
            border-left: 1px solid #ddd
        }
    }

    @media (min-width:960px) {
        .prodadmin-uk-grid-divider>[class*=prodadmin-uk-width-large-]:not(.prodadmin-uk-width-large-1-1):nth-child(n+2) {
            border-left: 1px solid #ddd
        }
    }

    @media (min-width:1220px) {
        .prodadmin-uk-grid-divider:not(:empty) {
            margin-left: -35px;
            margin-right: -35px
        }

        .prodadmin-uk-grid-divider>* {
            padding-left: 35px;
            padding-right: 35px
        }

        .prodadmin-uk-grid-divider:empty {
            margin-top: 35px;
            margin-bottom: 35px
        }
    }

    .prodadmin-uk-grid-divider:empty {
        margin-top: 25px;
        margin-bottom: 25px;
        border-top: 1px solid #ddd
    }

    .prodadmin-uk-grid-match>* {
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -ms-flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap
    }

    .prodadmin-uk-grid-match>*>* {
        -ms-flex: none;
        -webkit-flex: none;
        flex: none;
        box-sizing: border-box;
        width: 100%
    }

    /* [class*=prodadmin-uk-grid-width]>*{
    box-sizing:border-box;
    width:100%
} */
    .prodadmin-uk-grid-width-1-2>* {
        width: 50%
    }

    .prodadmin-uk-grid-width-1-3>* {
        width: 33.333%
    }

    .prodadmin-uk-grid-width-1-4>* {
        width: 25%
    }

    .prodadmin-uk-grid-width-1-5>* {
        width: 20%
    }

    .prodadmin-uk-grid-width-1-6>* {
        width: 16.666%
    }

    .prodadmin-uk-grid-width-1-10>* {
        width: 10%
    }

    .prodadmin-uk-grid-width-auto>* {
        width: auto
    }

    @media (min-width:480px) {
        .prodadmin-uk-grid-width-small-1-1>* {
            width: 100%
        }

        .prodadmin-uk-grid-width-small-1-2>* {
            width: 50%
        }

        .prodadmin-uk-grid-width-small-1-3>* {
            width: 33.333%
        }

        .prodadmin-uk-grid-width-small-1-4>* {
            width: 25%
        }

        .prodadmin-uk-grid-width-small-1-5>* {
            width: 20%
        }

        .prodadmin-uk-grid-width-small-1-6>* {
            width: 16.666%
        }

        .prodadmin-uk-grid-width-small-1-10>* {
            width: 10%
        }
    }

    @media (min-width:768px) {
        .prodadmin-uk-grid-width-medium-1-1>* {
            width: 100%
        }

        .prodadmin-uk-grid-width-medium-1-2>* {
            width: 50%
        }

        .prodadmin-uk-grid-width-medium-1-47>* {
            width: 47.333%
        }

        .prodadmin-uk-grid-width-medium-1-3>* {
            width: 33.333%
        }

        .prodadmin-uk-grid-width-medium-1-4>* {
            width: 25%
        }

        .prodadmin-uk-grid-width-medium-1-5>* {
            width: 20%
        }

        .prodadmin-uk-grid-width-medium-1-6>* {
            width: 16.666%
        }

        .prodadmin-uk-grid-width-medium-1-10>* {
            width: 10%
        }
    }

    @media (min-width:960px) {
        .prodadmin-uk-grid-width-large-1-1>* {
            width: 100%
        }

        .prodadmin-uk-grid-width-large-1-2>* {
            width: 50%
        }

        .prodadmin-uk-grid-width-large-1-47>* {
            width: 47.333%
        }

        .prodadmin-uk-grid-width-large-1-3>* {
            width: 33.333%
        }

        .prodadmin-uk-grid-width-large-1-4>* {
            width: 25%
        }

        .prodadmin-uk-grid-width-large-1-32>* {
            width: 32%
        }

        .prodadmin-uk-grid-width-large-1-5>* {
            width: 20%
        }

        .prodadmin-uk-grid-width-large-1-6>* {
            width: 16.666%
        }

        .prodadmin-uk-grid-width-large-1-10>* {
            width: 10%
        }
    }

    @media (min-width:1220px) {
        .prodadmin-uk-grid-width-xlarge-1-1>* {
            width: 100%
        }

        .prodadmin-uk-grid-width-xlarge-1-2>* {
            width: 50%
        }

        .prodadmin-uk-grid-width-xlarge-1-3>* {
            width: 33.333%
        }

        .prodadmin-uk-grid-width-xlarge-1-31>* {
            width: 32.333%
        }

        .prodadmin-uk-grid-width-xlarge-1-4>* {
            width: 25%
        }

        .prodadmin-uk-grid-width-xlarge-1-5>* {
            width: 20%
        }

        .prodadmin-uk-grid-width-xlarge-1-24>* {
            width: 24%;
        }

        .prodadmin-uk-grid-width-xlarge-1-6>* {
            width: 16.666%
        }

        .prodadmin-uk-grid-width-xlarge-1-16>* {
            width: 16% !important;
        }

        .prodadmin-uk-grid-width-xlarge-1-10>* {
            width: 10%
        }
    }

    [class*=prodadmin-uk-width] {
        box-sizing: border-box;
        width: 100%
    }

    .prodadmin-uk-width-1-1 {
        width: 100%
    }

    .prodadmin-uk-width-1-2,
    .prodadmin-uk-width-2-4,
    .prodadmin-uk-width-3-6,
    .prodadmin-uk-width-5-10 {
        width: 50%
    }

    .prodadmin-uk-width-1-3,
    .prodadmin-uk-width-2-6 {
        width: 33.333%
    }

    .prodadmin-uk-width-2-3,
    .prodadmin-uk-width-4-6 {
        width: 66.666%
    }

    .prodadmin-uk-width-1-4 {
        width: 25%
    }

    .prodadmin-uk-width-3-4 {
        width: 75%
    }

    .prodadmin-uk-width-1-5,
    .prodadmin-uk-width-2-10 {
        width: 20%
    }

    .prodadmin-uk-width-2-5,
    .prodadmin-uk-width-4-10 {
        width: 40%
    }

    .prodadmin-uk-width-3-5,
    .prodadmin-uk-width-6-10 {
        width: 60%
    }

    .prodadmin-uk-width-4-5,
    .prodadmin-uk-width-8-10 {
        width: 80%
    }

    .prodadmin-uk-width-1-6 {
        width: 16.666%
    }

    .prodadmin-uk-width-5-6 {
        width: 83.333%
    }

    .prodadmin-uk-width-1-10 {
        width: 10%
    }

    .prodadmin-uk-width-3-10 {
        width: 30%
    }

    .prodadmin-uk-width-7-10 {
        width: 70%
    }

    .prodadmin-uk-width-9-10 {
        width: 90%
    }

    @media (min-width:480px) {
        .prodadmin-uk-width-small-1-1 {
            width: 100%
        }

        .prodadmin-uk-width-small-1-2,
        .prodadmin-uk-width-small-2-4,
        .prodadmin-uk-width-small-3-6,
        .prodadmin-uk-width-small-5-10 {
            width: 50%
        }

        .prodadmin-uk-width-small-1-3,
        .prodadmin-uk-width-small-2-6 {
            width: 33.333%
        }

        .prodadmin-uk-width-small-2-3,
        .prodadmin-uk-width-small-4-6 {
            width: 66.666%
        }

        .prodadmin-uk-width-small-1-4 {
            width: 25%
        }

        .prodadmin-uk-width-small-3-4 {
            width: 75%
        }

        .prodadmin-uk-width-small-1-5,
        .prodadmin-uk-width-small-2-10 {
            width: 20%
        }

        .prodadmin-uk-width-small-2-5,
        .prodadmin-uk-width-small-4-10 {
            width: 40%
        }

        .prodadmin-uk-width-small-3-5,
        .prodadmin-uk-width-small-6-10 {
            width: 60%
        }

        .prodadmin-uk-width-small-4-5,
        .prodadmin-uk-width-small-8-10 {
            width: 80%
        }

        .prodadmin-uk-width-small-1-6 {
            width: 16.666%
        }

        .prodadmin-uk-width-small-5-6 {
            width: 83.333%
        }

        .prodadmin-uk-width-small-1-10 {
            width: 10%
        }

        .prodadmin-uk-width-small-3-10 {
            width: 30%
        }

        .prodadmin-uk-width-small-7-10 {
            width: 70%
        }

        .prodadmin-uk-width-small-9-10 {
            width: 90%
        }
    }

    @media (min-width:768px) {
        .prodadmin-uk-width-medium-1-1 {
            width: 100%
        }

        .prodadmin-uk-width-medium-1-2,
        .prodadmin-uk-width-medium-2-4,
        .prodadmin-uk-width-medium-3-6,
        .prodadmin-uk-width-medium-5-10 {
            width: 50%
        }

        .prodadmin-uk-width-medium-1-3,
        .prodadmin-uk-width-medium-2-6 {
            width: 33.333%
        }

        .prodadmin-uk-width-medium-2-3,
        .prodadmin-uk-width-medium-4-6 {
            width: 66.666%
        }

        .prodadmin-uk-width-medium-1-4 {
            width: 25%
        }

        .prodadmin-uk-width-medium-3-4 {
            width: 75%
        }

        .prodadmin-uk-width-medium-1-5,
        .prodadmin-uk-width-medium-2-10 {
            width: 20%
        }

        .prodadmin-uk-width-medium-2-5,
        .prodadmin-uk-width-medium-4-10 {
            width: 40%
        }

        .prodadmin-uk-width-medium-3-5,
        .prodadmin-uk-width-medium-6-10 {
            width: 60%
        }

        .prodadmin-uk-width-medium-4-5,
        .prodadmin-uk-width-medium-8-10 {
            width: 80%
        }

        .prodadmin-uk-width-medium-1-6 {
            width: 16.666%
        }

        .prodadmin-uk-width-medium-5-6 {
            width: 83.333%
        }

        .prodadmin-uk-width-medium-1-10 {
            width: 10%
        }

        .prodadmin-uk-width-medium-3-10 {
            width: 30%
        }

        .prodadmin-uk-width-medium-7-10 {
            width: 70%
        }

        .prodadmin-uk-width-medium-9-10 {
            width: 90%
        }
    }

    @media (min-width:960px) {
        .prodadmin-uk-width-large-1-1 {
            width: 100%
        }

        .prodadmin-uk-width-large-1-2,
        .prodadmin-uk-width-large-2-4,
        .prodadmin-uk-width-large-3-6,
        .prodadmin-uk-width-large-5-10 {
            width: 50%
        }

        .prodadmin-uk-width-large-1-3,
        .prodadmin-uk-width-large-2-6 {
            width: 33.333%
        }

        .prodadmin-uk-width-large-2-3,
        .prodadmin-uk-width-large-4-6 {
            width: 66.666%
        }

        .prodadmin-uk-width-large-1-4 {
            width: 25%
        }

        .prodadmin-uk-width-large-3-4 {
            width: 75%
        }

        .prodadmin-uk-width-large-1-5,
        .prodadmin-uk-width-large-2-10 {
            width: 20%
        }

        .prodadmin-uk-width-large-2-5,
        .prodadmin-uk-width-large-4-10 {
            width: 40%
        }

        .prodadmin-uk-width-large-3-5,
        .prodadmin-uk-width-large-6-10 {
            width: 60%
        }

        .prodadmin-uk-width-large-4-5,
        .prodadmin-uk-width-large-8-10 {
            width: 80%
        }

        .prodadmin-uk-width-large-1-6 {
            width: 16.666%
        }

        .prodadmin-uk-width-large-5-6 {
            width: 83.333%
        }

        .prodadmin-uk-width-large-1-10 {
            width: 10%
        }

        .prodadmin-uk-width-large-3-10 {
            width: 30%
        }

        .prodadmin-uk-width-large-7-10 {
            width: 70%
        }

        .prodadmin-uk-width-large-9-10 {
            width: 90%
        }
    }

    @media (min-width:1220px) {
        .prodadmin-uk-width-xlarge-1-1 {
            width: 100%
        }

        .prodadmin-uk-width-xlarge-1-2,
        .prodadmin-uk-width-xlarge-2-4,
        .prodadmin-uk-width-xlarge-3-6,
        .prodadmin-uk-width-xlarge-5-10 {
            width: 50%
        }

        .prodadmin-uk-width-xlarge-1-3,
        .prodadmin-uk-width-xlarge-2-6 {
            width: 33.333%
        }

        .prodadmin-uk-width-xlarge-2-3,
        .prodadmin-uk-width-xlarge-4-6 {
            width: 66.666%
        }

        .prodadmin-uk-width-xlarge-1-4 {
            width: 25%
        }

        .prodadmin-uk-width-xlarge-3-4 {
            width: 75%
        }

        .prodadmin-uk-width-xlarge-1-5,
        .prodadmin-uk-width-xlarge-2-10 {
            width: 20%
        }

        .prodadmin-uk-width-xlarge-2-5,
        .prodadmin-uk-width-xlarge-4-10 {
            width: 40%
        }

        .prodadmin-uk-width-xlarge-3-5,
        .prodadmin-uk-width-xlarge-6-10 {
            width: 60%
        }

        .prodadmin-uk-width-xlarge-4-5,
        .prodadmin-uk-width-xlarge-8-10 {
            width: 80%
        }

        .prodadmin-uk-width-xlarge-1-6 {
            width: 16.666%
        }

        .prodadmin-uk-width-xlarge-5-6 {
            width: 83.333%
        }

        .prodadmin-uk-width-xlarge-1-10 {
            width: 10%
        }

        .prodadmin-uk-width-xlarge-3-10 {
            width: 30%
        }

        .prodadmin-uk-width-xlarge-7-10 {
            width: 70%
        }

        .prodadmin-uk-width-xlarge-9-10 {
            width: 90%
        }
    }

    @media (min-width:768px) {

        [class*=prodadmin-uk-push-],
        [class*=prodadmin-uk-pull-] {
            position: relative
        }

        .prodadmin-uk-push-1-2,
        .prodadmin-uk-push-2-4,
        .prodadmin-uk-push-3-6,
        .prodadmin-uk-push-5-10 {
            left: 50%
        }

        .prodadmin-uk-push-1-3,
        .prodadmin-uk-push-2-6 {
            left: 33.333%
        }

        .prodadmin-uk-push-2-3,
        .prodadmin-uk-push-4-6 {
            left: 66.666%
        }

        .prodadmin-uk-push-1-4 {
            left: 25%
        }

        .prodadmin-uk-push-3-4 {
            left: 75%
        }

        .prodadmin-uk-push-1-5,
        .prodadmin-uk-push-2-10 {
            left: 20%
        }

        .prodadmin-uk-push-2-5,
        .prodadmin-uk-push-4-10 {
            left: 40%
        }

        .prodadmin-uk-push-3-5,
        .prodadmin-uk-push-6-10 {
            left: 60%
        }

        .prodadmin-uk-push-4-5,
        .prodadmin-uk-push-8-10 {
            left: 80%
        }

        .prodadmin-uk-push-1-6 {
            left: 16.666%
        }

        .prodadmin-uk-push-5-6 {
            left: 83.333%
        }

        .prodadmin-uk-push-1-10 {
            left: 10%
        }

        .prodadmin-uk-push-3-10 {
            left: 30%
        }

        .prodadmin-uk-push-7-10 {
            left: 70%
        }

        .prodadmin-uk-push-9-10 {
            left: 90%
        }

        .prodadmin-uk-pull-1-2,
        .prodadmin-uk-pull-2-4,
        .prodadmin-uk-pull-3-6,
        .prodadmin-uk-pull-5-10 {
            left: -50%
        }

        .prodadmin-uk-pull-1-3,
        .prodadmin-uk-pull-2-6 {
            left: -33.333%
        }

        .prodadmin-uk-pull-2-3,
        .prodadmin-uk-pull-4-6 {
            left: -66.666%
        }

        .prodadmin-uk-pull-1-4 {
            left: -25%
        }

        .prodadmin-uk-pull-3-4 {
            left: -75%
        }

        .prodadmin-uk-pull-1-5,
        .prodadmin-uk-pull-2-10 {
            left: -20%
        }

        .prodadmin-uk-pull-2-5,
        .prodadmin-uk-pull-4-10 {
            left: -40%
        }

        .prodadmin-uk-pull-3-5,
        .prodadmin-uk-pull-6-10 {
            left: -60%
        }

        .prodadmin-uk-pull-4-5,
        .prodadmin-uk-pull-8-10 {
            left: -80%
        }

        .prodadmin-uk-pull-1-6 {
            left: -16.666%
        }

        .prodadmin-uk-pull-5-6 {
            left: -83.333%
        }

        .prodadmin-uk-pull-1-10 {
            left: -10%
        }

        .prodadmin-uk-pull-3-10 {
            left: -30%
        }

        .prodadmin-uk-pull-7-10 {
            left: -70%
        }

        .prodadmin-uk-pull-9-10 {
            left: -90%
        }
    }

    .prodadmin-uk-panel {
        display: block;
        position: relative
    }

    .prodadmin-uk-panel,
    .prodadmin-uk-panel:hover {
        text-decoration: none
    }

    .prodadmin-uk-panel:after,
    .prodadmin-uk-panel:before {
        content: "";
        display: table
    }

    .prodadmin-uk-panel:after {
        clear: both
    }

    .prodadmin-uk-panel>:not(.prodadmin-uk-panel-title):last-child {
        margin-bottom: 0
    }

    .prodadmin-uk-panel-title {
        margin-top: 0;
        margin-bottom: 15px;
        font-size: 18px;
        line-height: 24px;
        font-weight: 400;
        text-transform: none;
        color: #444
    }

    .prodadmin-uk-panel-badge {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1
    }

    .prodadmin-uk-panel-teaser {
        margin-bottom: 15px
    }

    .prodadmin-uk-panel-body {
        padding: 15px
    }

    .prodadmin-uk-panel-box {
        padding: 15px;
        background: #fafafa;
        color: #444;
        border: 1px solid #ddd;
        border-radius: 4px
    }

    .prodadmin-uk-panel-box-hover:hover {
        color: #444
    }

    .prodadmin-uk-panel-box .prodadmin-uk-panel-title {
        color: #444
    }

    .prodadmin-uk-panel-box .prodadmin-uk-panel-badge {
        top: 10px;
        right: 10px
    }

    .prodadmin-uk-panel-box>.prodadmin-uk-panel-teaser {
        margin-top: -16px;
        margin-left: -16px;
        margin-right: -16px
    }

    .prodadmin-uk-panel-box>.prodadmin-uk-nav-side {
        margin: 0 -15px
    }

    .prodadmin-uk-panel-box-primary {
        background-color: #ebf7fd;
        color: #2d7091;
        border-color: rgba(45, 112, 145, .3)
    }

    .prodadmin-uk-panel-box-primary-hover:hover {
        color: #2d7091
    }

    .prodadmin-uk-panel-box-primary .prodadmin-uk-panel-title {
        color: #2d7091
    }

    .prodadmin-uk-panel-box-secondary {
        background-color: #fff;
        color: #444
    }

    .prodadmin-uk-panel-box-secondary-hover:hover {
        color: #444
    }

    .prodadmin-uk-panel-box-secondary .prodadmin-uk-panel-title {
        color: #444
    }

    .prodadmin-uk-panel-hover {
        padding: 15px;
        color: #444;
        border: 1px solid transparent;
        border-radius: 4px
    }

    .prodadmin-uk-panel-hover:hover {
        background: #fafafa;
        color: #444;
        border-color: #ddd
    }

    .prodadmin-uk-panel-hover .prodadmin-uk-panel-badge {
        top: 10px;
        right: 10px
    }

    .prodadmin-uk-panel-hover>.prodadmin-uk-panel-teaser {
        margin-top: -16px;
        margin-left: -16px;
        margin-right: -16px
    }

    .prodadmin-uk-panel-header .prodadmin-uk-panel-title {
        padding-bottom: 10px;
        border-bottom: 1px solid #ddd;
        color: #444
    }

    .prodadmin-uk-panel-space {
        padding: 30px
    }

    .prodadmin-uk-panel-space .prodadmin-uk-panel-badge {
        top: 30px;
        right: 30px
    }

    .prodadmin-uk-panel+.prodadmin-uk-panel-divider {
        margin-top: 50px !important
    }

    .prodadmin-uk-panel+.prodadmin-uk-panel-divider:before {
        content: "";
        display: block;
        position: absolute;
        top: -25px;
        left: 0;
        right: 0;
        border-top: 1px solid #ddd
    }

    @media (min-width:1220px) {
        .prodadmin-uk-panel+.prodadmin-uk-panel-divider {
            margin-top: 70px !important
        }

        .prodadmin-uk-panel+.prodadmin-uk-panel-divider:before {
            top: -35px
        }
    }

    .prodadmin-uk-panel-box .prodadmin-uk-panel-teaser {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        overflow: hidden;
        -webkit-transform: translateZ(0)
    }

    .prodadmin-uk-block {
        position: relative;
        box-sizing: border-box;
        padding-top: 20px;
        padding-bottom: 20px
    }

    @media (min-width:768px) {
        .prodadmin-uk-block {
            padding-top: 50px;
            padding-bottom: 50px
        }
    }

    .prodadmin-uk-block:after,
    .prodadmin-uk-block:before {
        content: "";
        display: table
    }

    .prodadmin-uk-block:after {
        clear: both
    }

    .prodadmin-uk-block>:last-child {
        margin-bottom: 0
    }

    .prodadmin-uk-block-large {
        padding-top: 20px;
        padding-bottom: 20px
    }

    @media (min-width:768px) {
        .prodadmin-uk-block-large {
            padding-top: 50px;
            padding-bottom: 50px
        }
    }

    @media (min-width:960px) {
        .prodadmin-uk-block-large {
            padding-top: 100px;
            padding-bottom: 100px
        }
    }

    .prodadmin-uk-block-default {
        background: #fff
    }

    .prodadmin-uk-block-muted {
        background: #f9f9f9
    }

    .prodadmin-uk-block-primary {
        background: #00a8e6
    }

    .prodadmin-uk-block-secondary {
        background: #222
    }

    .prodadmin-uk-block-default+.prodadmin-uk-block-default,
    .prodadmin-uk-block-muted+.prodadmin-uk-block-muted,
    .prodadmin-uk-block-primary+.prodadmin-uk-block-primary,
    .prodadmin-uk-block-secondary+.prodadmin-uk-block-secondary {
        padding-top: 0
    }

    .md-card.adminproducts-card {
        position: relative;
        cursor: pointer;
        border-radius: 6px;
        -webkit-backdrop-filter: blur(30px);
        backdrop-filter: blur(30px);
        border: solid 0px #00448b;
        background-color: #00448b;
    }

    .md-card.adminproducts-card+.md-card.adminproducts-card,
    .md-card.adminproducts-card+.prodadmin-uk-grid,
    .prodadmin-uk-grid+.md-card.adminproducts-card {
        margin-top: 25px
    }

    .md-card.adminproducts-card .full_width_in_card {
        padding: 16px 24px;
        background: rgba(0, 0, 0, .085)
    }

    .md-card.adminproducts-card .md-card-toolbar {
        height: 48px;
        padding: 0 16px;
        border-bottom: 1px solid rgba(0, 0, 0, .12);
        background: #fff
    }

    .md-card.adminproducts-card .md-card-toolbar:after,
    .md-card.adminproducts-card .md-card-toolbar:before {
        content: " ";
        display: table
    }

    .md-card.adminproducts-card .md-card-toolbar:after {
        clear: both
    }

    .md-card.adminproducts-card .md-card-toolbar:after,
    .md-card.adminproducts-card .md-card-toolbar:before {
        content: " ";
        display: table
    }

    .md-card.adminproducts-card .md-card-toolbar:after {
        clear: both
    }

    .md-card.adminproducts-card .md-card-toolbar-heading-text {
        font: 500 14px/50px Roboto, sans-serif;
        color: #212121;
        margin: 0;
        float: left;
        overflow: hidden;
        height: 48px
    }

    .md-card.adminproducts-card .md-card-toolbar-heading-text.large {
        font-size: 18px;
        font-weight: 400
    }

    .md-card.adminproducts-card .md-card-toolbar .md-toggle-group {
        float: left;
        margin: 8px 0 0 16px
    }

    .md-card.adminproducts-card .md-card-toolbar .md-toggle-group.md-toggle-group-small {
        margin-top: 10px
    }

    .md-card.adminproducts-card .md-card-toolbar .md-card-toolbar-actions {
        float: right;
        padding-top: 10px
    }

    .md-card.adminproducts-card .md-card-toolbar .md-card-toolbar-actions .prodadmin-uk-open .md-card-toolbar-icon {
        background: rgba(0, 0, 0, .085);
        color: #212121
    }

    .md-card.adminproducts-card .md-card-toolbar .md-card-toolbar-actions .md-card-dropdown {
        display: inline-block;
        position: relative
    }

    .md-card.adminproducts-card .md-card-toolbar .md-card-toolbar-actions .selectize-control {
        min-width: 220px;
        margin-top: -3px
    }

    .md-card.adminproducts-card .md-card-toolbar .md-card-toolbar-actions .selectize-control .selectize-input {
        min-height: 30px;
        padding: 4px 8px
    }

    .md-card.adminproducts-card .md-card-toolbar .md-card-toolbar-actions .selectize-control .selectize-dropdown {
        margin-top: -34px
    }

    .md-card.adminproducts-card .md-card-toolbar .md-icon+.md-card-dropdown {
        margin-left: 4px
    }

    .md-card.adminproducts-card .md-card-toolbar .md-card-fullscreen-deactivate {
        margin: 9px 8px 0 0
    }

    .md-card.adminproducts-card .md-card-toolbar-input {
        border: none;
        font: 400 18px/24px Roboto, sans-serif;
        height: auto;
        background: 0 0 !important;
        padding: 12px 0;
        width: 50%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box
    }

    .md-card.adminproducts-card .md-card-toolbar .prodadmin-uk-tab {
        margin-top: -2px;
        border-bottom: none
    }

    .md-card.adminproducts-card .md-card-toolbar .prodadmin-uk-tab li>a {
        padding: 10px 8px !important
    }

    .md-card.adminproducts-card .md-card-head {
        height: auto;
        position: relative;
        border-bottom: 1px solid transparent
    }

    .md-card.adminproducts-card:hover {
        -webkit-box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.15);
        box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.15);
    }

    .md-card.adminproducts-card .md-card-head-menu {
        position: absolute;
        right: 8px;
        top: 8px;
        border: 1px solid #e0e3e6;
        border-radius: 4px;
        background: #fff;
    }

    .profile-img-div {
        background-color: rgba(255, 255, 255, 0);
        width: 86px;
        height: 86px;
        border-radius: 50%;
        margin-top: 20px;
        display: inline-block;
        border: 2px solid;
    }

    .md-card.adminproducts-card .md-card-head-avatar {
        width: 75px;
        height: 75px;
        border-radius: 50%;
        margin-top: 4px;
        display: inline-block
    }

    .md-card.adminproducts-card .md-card-head-text {
        padding: 8px 10px 8px;
        font-size: 15px;
        color: #00448b;
        margin: 0;
        font-weight: 600;
        line-height: 1.19;
    }

    .md-card.adminproducts-card .md-card-head-text span:not(.listNavSelector) {
        display: block;
        font-size: 13px;
        margin-top: 5px;
        margin-bottom: 0px;
        color: #00448b;
        font-weight: 400;
        line-height: 1.25;
    }

    .md-card.adminproducts-card .md-card-head-text.text_dark {
        color: #303031 !important
    }

    .md-card.adminproducts-card .md-card-head-text-over {
        background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, .65)), to(rgba(0, 0, 0, 0)));
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, .65) 0, rgba(0, 0, 0, 0) 100%)
    }

    .md-card.adminproducts-card .md-card-head-subtext {
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
        padding: 0 16px;
        text-align: right;
        color: #fff
    }

    .md-card.adminproducts-card .md-card-head-subtext span {
        font-size: 26px
    }

    .md-card.adminproducts-card .md-card-head-icon {
        font-size: 48px;
        color: #fff;
        vertical-align: middle
    }

    .md-card.adminproducts-card .md-card-head.head_background {
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        border-bottom-color: transparent
    }

    .md-card.adminproducts-card .md-card-head.head_background .md-card-head-text {
        color: #fff
    }

    .md-card.adminproducts-card .md-card-head.head_background_top {
        background-repeat: no-repeat;
        background-position: center top
    }

    .md-card.adminproducts-card .md-card-head.head_background_bottom {
        background-repeat: no-repeat;
        background-position: center bottom
    }

    .md-card.adminproducts-card .md-card-head .head_chart {
        height: 100px;
        width: 100%;
        position: absolute !important;
        left: 0;
        top: 40px
    }

    .md-card.adminproducts-card .md-card-head .fitVid_player {
        width: 100%;
        height: 160px;
        overflow: hidden
    }

    .md-card.adminproducts-card .md-card-head-img {
        height: 100%;
        width: auto;
    }

    .md-card.adminproducts-card .md-card-head iframe {
        height: 160px
    }

    .md-card.adminproducts-card .md-card-content {
        padding: 5px 12px 12px;
    }

    .md-card.adminproducts-card .md-card-content.padding-reset {
        padding: 0
    }

    .md-card.adminproducts-card .md-card-content.large-padding {
        padding: 24px 35px
    }

    .md-card.adminproducts-card .md-card-content.small-padding {
        padding: 8px
    }

    .md-card.md-card-fullscreen-activate {
        cursor: pointer
    }

    .md-card.md-card-fullscreen {
        position: fixed;
        z-index: 9998;
        overflow-x: hidden;
        cursor: default
    }

    .md-card.md-card-fullscreen .md-card-fullscreen-activate {
        display: none
    }

    .md-card.md-card-fullscreen .md-card-fullscreen-hide {
        display: none
    }

    .md-card.adminproducts-card .md-card-fullscreen-content {
        display: none;
        padding: 16px
    }

    .md-card-fullscreen-content-hidden .md-card.adminproducts-card .md-card-fullscreen-content {
        display: block;
        visibility: hidden;
        padding: 0
    }

    .md-card.mdToolbar_fixed {
        overflow-y: hidden
    }

    .md-card.mdToolbar_fixed>.md-card-toolbar {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        z-index: 9999;
        -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, .16), 0 3px 6px rgba(0, 0, 0, .23);
        box-shadow: 0 3px 6px rgba(0, 0, 0, .16), 0 3px 6px rgba(0, 0, 0, .23)
    }

    .md-card.mdToolbar_fixed>.md-card-content {
        overflow-y: scroll;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: absolute;
        width: 100%;
        top: 48px;
        bottom: 0
    }

    .md-card.mdToolbar_fixed>.md-card-content .md-card-fullscreen-content {
        padding: 16px 0
    }

    .md-card.adminproducts-card.md-card-overlay {
        overflow: hidden;
        padding-bottom: 54px
    }

    .md-card.adminproducts-card .md-card-overlay .md-card-content {
        height: 142px;
        overflow: hidden;
        -webkit-box-sizing: border-box;
        box-sizing: border-box
    }

    .md-card.adminproducts-card .md-card-overlay .md-card-content.no_truncate {
        position: relative
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-content.no_truncate:after {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 8px;
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #fff), to(rgba(255, 255, 255, 0)));
        background-image: linear-gradient(to top, #fff 50%, rgba(255, 255, 255, 0) 100%);
        display: block;
        content: '';
        z-index: 10
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-content>pre {
        margin-top: 0;
        max-height: 110px
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-content>pre>code {
        overflow: hidden
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-content {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        padding: 0 16px;
        margin-top: -54px;
        border-top: 1px solid rgba(0, 0, 0, .12);
        text-align: left;
        bottom: 0;
        background: #fff;
        z-index: 10;
        -webkit-transition: all 280ms cubic-bezier(.4, 0, .2, 1);
        transition: all 280ms cubic-bezier(.4, 0, .2, 1)
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-content p {
        margin: 0
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-content p+* {
        margin-top: 16px
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-content p+p {
        margin-top: 4px
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-header {
        padding: 12px 0
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-header:after,
    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-header:before {
        content: " ";
        display: table
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-header:after {
        clear: both
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-header:after,
    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-header:before {
        content: " ";
        display: table
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-header:after {
        clear: both
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-header h3,
    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-header h4 {
        margin: 0;
        text-overflow: ellipsis;
        display: inline-block;
        vertical-align: top;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
        padding-right: 32px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box
    }

    .md-card.adminproducts-card.md-card-overlay .md-card-overlay-header .md-icon {
        position: absolute;
        right: 12px;
        top: 11px
    }

    .md-card.adminproducts-card.md-card-overlay-active .md-card-overlay-content {
        top: -1px;
        margin-top: 0
    }

    /* .md-card.md-card-hover{
    -webkit-transition:all 280ms cubic-bezier(.4,0,.2,1);
    transition:all 280ms cubic-bezier(.4,0,.2,1);
    will-change:box-shadow
}
.md-card.md-card-hover:hover{
    -webkit-box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);
    box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)
} */
    .prodadmin-uk-sortable-dragged .md-card {
        -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, .19), 0 6px 6px rgba(0, 0, 0, .23);
        box-shadow: 0 10px 20px rgba(0, 0, 0, .19), 0 6px 6px rgba(0, 0, 0, .23)
    }

    .prodadmin-uk-sortable-dragged .md-card.adminproducts-card canvas {
        margin: 0 auto;
        display: block
    }

    .md-card.adminproducts-card .heading_list {
        padding: 0
    }

    .md-card-danger,
    .md-card-primary,
    .md-card-success,
    .md-card-warning {
        border-left: 4px solid transparent
    }

    .md-card-primary {
        border-left-color: #00448b
    }

    .md-card-success {
        border-left-color: #7cb342
    }

    .md-card-danger {
        border-left-color: #e53935
    }

    .md-card-warning {
        border-left-color: #ffa000
    }

    .md-card-horizontal {
        position: relative;
        min-height: 200px
    }

    .md-card-horizontal:after,
    .md-card-horizontal:before {
        content: " ";
        display: table
    }

    .md-card-horizontal:after {
        clear: both
    }

    .md-card-horizontal:after,
    .md-card-horizontal:before {
        content: " ";
        display: table
    }

    .md-card-horizontal:after {
        clear: both
    }

    .md-card-horizontal-grid {
        min-height: auto
    }

    .md-card-horizontal .md-card-head {
        border-right: 1px solid rgba(0, 0, 0, .12);
        border-bottom: none;
        width: 200px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0
    }

    @media only screen and (max-width:767px) {
        .md-card-horizontal .md-card-head {
            width: 140px
        }
    }

    .md-card-horizontal .md-card-head-grid {
        border-right: 1px solid rgba(0, 0, 0, .12)
    }

    .md-card-horizontal .md-card-head-menu {
        right: auto;
        left: 8px
    }

    .md-card-horizontal .md-card-content {
        margin-left: 200px
    }

    @media only screen and (max-width:767px) {
        .md-card-horizontal .md-card-content {
            margin-left: 140px
        }
    }

    .md-card-horizontal .md-card-content-grid {
        padding: 16px
    }

    .md-expand,
    .md-expand-group>* {
        opacity: 0
    }

    .md-card-placeholder {
        min-width: 100%
    }

    .md-card-list-wrapper,
    .md-card-list-wrapper *,
    .md-card-list-wrapper :after,
    .md-card-list-wrapper :before,
    .md-card-list-wrapper:after,
    .md-card-list-wrapper:before {
        -webkit-box-sizing: border-box;
        box-sizing: border-box
    }

    .md-card-list-wrapper .md-card-list-header {
        position: absolute;
        top: -24px;
        left: 0
    }

    .md-card-list-wrapper .md-card-list {
        margin: 48px 0 0 0;
        position: relative
    }

    .md-card-list-wrapper .md-card-list:first-child {
        margin-top: 24px
    }

    .md-card-list-wrapper .md-card-list>ul {
        margin: 0;
        padding: 0;
        list-style: none
    }

    .md-card-list-wrapper .md-card-list>ul>li {
        padding: 0;
        margin: 0;
        list-style: none
    }

    .md-card-list-wrapper .md-card-list>ul>li {
        min-height: 34px;
        padding: 8px 16px;
        font-size: 13px;
        -webkit-transition: background 150ms, padding .2s;
        transition: background 150ms, padding .2s;
        background: #fff;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24);
        box-shadow: 0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24)
    }

    .md-card-list-wrapper .md-card-list>ul>li:after,
    .md-card-list-wrapper .md-card-list>ul>li:before {
        content: " ";
        display: table
    }

    .md-card-list-wrapper .md-card-list>ul>li:after {
        clear: both
    }

    .md-card-list-wrapper .md-card-list>ul>li:after,
    .md-card-list-wrapper .md-card-list>ul>li:before {
        content: " ";
        display: table
    }

    .md-card-list-wrapper .md-card-list>ul>li:after {
        clear: both
    }

    .md-card-list-wrapper .md-card-list>ul>li.item-shown {
        background: #fff;
        padding: 8px 36px
    }

    @media only screen and (max-width:767px) {
        .md-card-list-wrapper .md-card-list>ul>li.item-shown .md-card-list-item-subject {
            clear: both;
            float: none;
            padding-top: 16px
        }

        .md-card-list-wrapper .md-card-list>ul>li.item-shown .md-card-list-item-subject>span {
            white-space: normal
        }
    }

    .md-card-list-wrapper .md-card-list>ul>li.item-shown .md-card-list-item-sender {
        width: auto;
        overflow: hidden
    }

    .md-card-list-wrapper .md-card-list>ul>li.item-shown.md-card-list-item-selected {
        position: relative
    }

    .md-card-list-wrapper .md-card-list>ul>li.item-shown.md-card-list-item-selected:before {
        content: '';
        position: absolute;
        display: block;
        left: 0;
        top: 0;
        bottom: 0;
        width: 8px;
        background: #e3f2fd
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper,
    .md-card-list-wrapper .md-card-list .md-card-list-item-select,
    .md-card-list-wrapper .md-card-list .md-card-list-item-sender {
        float: left
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-select {
        padding: 6px 8px 0 0
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper,
    .md-card-list-wrapper .md-card-list .md-card-list-item-date,
    .md-card-list-wrapper .md-card-list .md-card-list-item-sender,
    .md-card-list-wrapper .md-card-list .md-card-list-item-subject {
        padding: 0 8px
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper .md-card-list-item-avatar {
        background: #757575;
        color: #fff;
        width: 34px;
        border-radius: 50%;
        display: block
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper .md-card-list-item-avatar-large {
        width: 82px;
        border-radius: 50%
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper span.md-card-list-item-avatar {
        line-height: 34px;
        text-transform: uppercase;
        text-align: center
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-sender {
        width: 220px;
        line-height: 34px
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-sender>span {
        text-overflow: ellipsis;
        display: inline-block;
        vertical-align: top;
        white-space: nowrap;
        overflow: hidden;
        width: 100%
    }

    @media only screen and (max-width:1219px) {
        .md-card-list-wrapper .md-card-list .md-card-list-item-sender {
            display: none
        }
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-subject {
        overflow: hidden;
        font-weight: 500
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-subject>span {
        line-height: 34px;
        text-overflow: ellipsis;
        display: inline-block;
        vertical-align: top;
        white-space: nowrap;
        overflow: hidden;
        width: 100%
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-subject .md-card-list-item-sender-small {
        display: none
    }

    @media only screen and (max-width:1219px) {
        .md-card-list-wrapper .md-card-list .md-card-list-item-subject .md-card-list-item-sender-small {
            display: block
        }

        .md-card-list-wrapper .md-card-list .md-card-list-item-subject .md-card-list-item-sender-small+span {
            line-height: inherit
        }
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-subject .md-card-list-item-sender-small>span {
        text-overflow: ellipsis;
        display: inline-block;
        vertical-align: top;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
        font-size: 12px;
        color: #999
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-date {
        line-height: 34px;
        float: right;
        color: #999
    }

    @media only screen and (max-width:479px) {
        .md-card-list-wrapper .md-card-list .md-card-list-item-date {
            display: none
        }
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-menu {
        float: right;
        margin: 0 0 0 8px;
        position: relative
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-menu .prodadmin-uk-dropdown .material-icons {
        margin-right: 8px
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-content-wrapper {
        display: none;
        clear: both;
        opacity: 0
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-content {
        padding: 16px 16px 0 0;
        max-height: 360px;
        overflow-x: hidden;
        margin: 0 0 40px;
        top: 20px;
        position: relative;
        font-size: 14px
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-content+.md-card-list-item-reply {
        padding-top: 10px
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-reply {
        padding: 16px 0
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-selected {
        background: #e3f2fd
    }

    .md-list {
        margin: 0;
        padding: 0;
        list-style: none
    }

    .md-list>li {
        padding: 0;
        margin: 0;
        list-style: none
    }

    .md-list,
    .md-list *,
    .md-list :after,
    .md-list :before,
    .md-list:after,
    .md-list:before {
        -webkit-box-sizing: border-box;
        box-sizing: border-box
    }

    .md-list .prodadmin-uk-nestable-list>li,
    .md-list>li {
        min-height: 48px;
        padding: 8px 4px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(0, 0, 0, .12);
        position: relative
    }

    .md-list .prodadmin-uk-nestable-list>li>.md-list-content,
    .md-list>li>.md-list-content {
        overflow: hidden
    }

    .md-list .prodadmin-uk-nestable-list>li>.md-list-content>span,
    .md-list>li>.md-list-content>span {
        display: block
    }

    .md-list .prodadmin-uk-nestable-list>li>.md-list-content .md-list-heading,
    .md-list>li>.md-list-content .md-list-heading {
        margin: 0;
        font-weight: 500;
        display: block;
        overflow: hidden;
        padding-bottom: 1px
    }

    .md-list .prodadmin-uk-nestable-list>li>.md-list-content .md-list-menu,
    .md-list>li>.md-list-content .md-list-menu {
        float: right
    }

    .md-list .prodadmin-uk-nestable-list>li>.md-list-content .md-list-menu .md-list-menu-toggle,
    .md-list>li>.md-list-content .md-list-menu .md-list-menu-toggle {
        display: block;
        font-size: 18px;
        color: rgba(0, 0, 0, .8);
        width: 28px;
        height: 28px;
        line-height: 28px;
        border-radius: 14px;
        text-align: center
    }

    .md-list .prodadmin-uk-nestable-list>li>.md-list-content .prodadmin-uk-badge,
    .md-list>li>.md-list-content .prodadmin-uk-badge {
        float: right;
        color: #fff !important
    }

    .md-list .prodadmin-uk-nestable-list>li>.md-list-content .md-list-action,
    .md-list>li>.md-list-content .md-list-action {
        float: right;
        margin-left: 8px;
        margin-top: 2px;
        display: none
    }

    .md-list .prodadmin-uk-nestable-list>li>.md-list-content .md-list-action-placeholder,
    .md-list>li>.md-list-content .md-list-action-placeholder {
        float: right;
        margin-left: 8px;
        display: none;
        width: 32px;
        height: 32px
    }

    .md-list .prodadmin-uk-nestable-list>li .md-list-action-dropdown,
    .md-list>li .md-list-action-dropdown {
        position: absolute;
        right: 16px;
        top: 10px;
        display: none
    }

    .md-list .prodadmin-uk-nestable-list>li>a.md-list-content,
    .md-list>li>a.md-list-content {
        display: block;
        color: #212121
    }

    .md-list .prodadmin-uk-nestable-list>li:last-child,
    .md-list>li:last-child {
        border-bottom: none
    }

    .md-list .prodadmin-uk-nestable-list>li.md-list-item-active,
    .md-list>li.md-list-item-active {
        color: #7cb342;
        background: #ededed
    }

    .md-list .prodadmin-uk-nestable-list>li.md-list-item-disabled>.md-list-content,
    .md-list>li.md-list-item-disabled>.md-list-content {
        color: #bdbdbd
    }

    .md-list .prodadmin-uk-nestable-list>li.md-list-item-disabled>.md-list-content span,
    .md-list>li.md-list-item-disabled>.md-list-content span {
        color: #bdbdbd !important
    }

    .md-list .prodadmin-uk-nestable-list>li.heading_list,
    .md-list>li.heading_list {
        min-height: 32px;
        padding: 32px 8px 16px;
        border-bottom: none;
        background: 0 0 !important;
        text-transform: uppercase
    }

    .md-list .prodadmin-uk-nestable-list>li:hover>.md-list-addon-element .prodadmin-uk-nestable-handle,
    .md-list>li:hover>.md-list-addon-element .prodadmin-uk-nestable-handle,
    .prodadmin-uk-touch .md-list .prodadmin-uk-nestable-list>li>.md-list-addon-element .prodadmin-uk-nestable-handle,
    .prodadmin-uk-touch .md-list>li>.md-list-addon-element .prodadmin-uk-nestable-handle {
        display: block
    }

    .md-list .prodadmin-uk-nestable-list>li:hover>.md-list-content .md-list-action,
    .md-list .prodadmin-uk-nestable-list>li:hover>.md-list-content .md-list-action-placeholder,
    .md-list>li:hover>.md-list-content .md-list-action,
    .md-list>li:hover>.md-list-content .md-list-action-placeholder,
    .prodadmin-uk-touch .md-list .prodadmin-uk-nestable-list>li>.md-list-content .md-list-action,
    .prodadmin-uk-touch .md-list .prodadmin-uk-nestable-list>li>.md-list-content .md-list-action-placeholder,
    .prodadmin-uk-touch .md-list>li>.md-list-content .md-list-action,
    .prodadmin-uk-touch .md-list>li>.md-list-content .md-list-action-placeholder {
        display: block
    }

    .md-list .prodadmin-uk-nestable-list>li:hover .md-list-action-dropdown,
    .md-list>li:hover .md-list-action-dropdown,
    .prodadmin-uk-touch .md-list .prodadmin-uk-nestable-list>li .md-list-action-dropdown,
    .prodadmin-uk-touch .md-list>li .md-list-action-dropdown {
        display: block
    }

    .md-list .prodadmin-uk-nestable-list>li {
        margin-left: 64px
    }

    .md-list-addon>li {
        margin-left: 64px;
        position: relative
    }

    .md-list-addon>li:last-child .md-list-addon-element {
        border-bottom: none;
        bottom: 0
    }

    .md-list-addon>li:first-child .md-list-addon-element {
        top: 0
    }

    .md-list-addon>li.md-list-item-active .md-list-addon-element,
    .md-list-addon>li.md-list-item-active .md-list-addon-element .material-icons {
        color: #7cb342
    }

    .md-list-addon-element {
        position: absolute;
        left: -64px;
        top: -1px;
        bottom: -1px;
        width: 64px;
        text-align: center;
        padding: 8px 0;
        display: block
    }

    .md-list-addon-element .element-status {
        position: absolute;
        right: 12px;
        top: 10px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #bdbdbd;
        border: 1px solid #fff
    }

    .md-list-addon-element .element-status-danger {
        background: #e53935
    }

    .md-list-addon-element .element-status-success {
        background: #7cb342
    }

    .md-list-addon-element .element-status-warning {
        background: #ffa000
    }

    .md-list-addon-element>.md-list-addon-avatar {
        margin-top: 2px
    }

    .md-list-addon-element>.md-list-addon-icon {
        font-size: 28px;
        margin-top: 4px;
        color: #727272
    }

    .md-list-addon-element>.material-icons {
        margin-top: 6px
    }

    .md-list-addon-element .icheckbox_md,
    .md-list-addon-element .iradio_md {
        margin-top: 10px
    }

    .md-list-addon-element .prodadmin-uk-nestable-handle {
        position: absolute;
        left: -2px;
        top: 12px;
        display: none
    }

    .md-list-interactive li {
        cursor: pointer
    }

    .md-list-bg {
        background: #fff
    }

    .md-list-separated li {
        background: #fff;
        padding: 8px
    }

    .md-list-separated li+li {
        border-top: none;
        margin-top: 8px
    }

    .md-list-bg-no-sep {
        background: #fff;
        padding: 8px
    }

    .md-list-bg-no-sep li>.md-list-content {
        padding: 0 4px
    }

    .md-list-outside>li {
        padding: 0
    }

    .md-list-outside>li>.md-list-content {
        padding: 8px 16px;
        display: block;
        color: #212121
    }

    .md-list-outside>li.md-list-item-active,
    .md-list-outside>li:hover:not(.heading_list) {
        background: rgba(0, 0, 0, .085)
    }

    .md-list-outside>li.heading_list {
        padding: 32px 16px 16px
    }

    .md-list-outside.md-list-addon li {
        margin-left: 0
    }

    .md-list-outside.md-list-addon li .md-list-addon-element {
        position: relative;
        top: auto;
        left: auto;
        float: left
    }

    .md-list-outside.md-list-addon li .md-list-content {
        padding-left: 0
    }

    .md-list-outside-wrapper {
        position: relative
    }

    .md-list-outside-wrapper .md-list-outside-search {
        position: absolute;
        top: -46px;
        left: 16px;
        right: 16px;
        z-index: 1000
    }

    .md-list-outside-wrapper .md-list-outside-search .md-input-wrapper {
        padding: 0
    }

    .md-list-outside-wrapper .md-list-outside-search .md-input-wrapper .md-input-bar:after,
    .md-list-outside-wrapper .md-list-outside-search .md-input-wrapper .md-input-bar:before {
        background: #fff
    }

    .md-list-outside-wrapper .md-list-outside-search .md-input {
        border-bottom-color: transparent !important
    }

    .md-list .prodadmin-uk-nestable-list {
        padding-left: 0
    }

    .md-list .prodadmin-uk-nestable-list .prodadmin-uk-nestable-item {
        padding-right: 0
    }

    .md-list .prodadmin-uk-nestable-item+.prodadmin-uk-nestable-item {
        margin-top: 0
    }

    .md-list-right.md-list-addon>li {
        margin-left: 0;
        margin-right: 64px
    }

    .md-list-right.md-list-addon>li .md-list-addon-element {
        left: auto;
        right: -64px
    }

    .prodadmin-uk-touch .md-list-addon-element .prodadmin-uk-nestable-handle {
        display: block !important
    }

    .prodadmin-uk-touch .md-list-content .md-list-action,
    .prodadmin-uk-touch .md-list-content .md-list-action-placeholder {
        display: block !important
    }

    .prodadmin-uk-touch .md-list-action-dropdown {
        display: block !important
    }

    .card-box.products-box {
        box-sizing: border-box;
        padding-left: 15px;
        padding-bottom: 20px;
        display: inline-block;
        max-width: 27rem !important;
    }

    .pink-box {
        box-shadow: 0 2px 10px 0 rgba(255, 38, 138, 0.55);
        background-color: #ff268a;
    }

    .blue-box {
        box-shadow: 0 2px 10px 0 rgba(13, 132, 242, 0.36);
        background-color: #00448b;
    }

    .lightblue-box {
        box-shadow: 0 2px 10px 0 rgba(13, 132, 242, 0.36);
        background-color: #50bcff;
    }

    .orange-box {
        box-shadow: 0 2px 10px 0 rgba(245, 166, 35, 0.35);
        background-color: #f5a623;
    }

    .border-orange1 {
        border-color: #ff7f00 !important;
    }

    .border-green1 {
        border-color: #1a9347 !important;
    }

    .border-red1 {
        border-color: #e82828 !important;
    }

    .border-blue1 {
        border-color: #00448b !important;
    }

    .card-group {
        margin-bottom: 2.143rem;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
    }

    .card-block {
        position: relative;
        padding: 1.429rem;
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 auto;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
    }

    .card.card-block {
        box-shadow: none;
    }

    @media (min-width: 480px) {

        .card-group {
            -webkit-flex-flow: row wrap;
            -ms-flex-flow: row wrap;
            flex-flow: row wrap;
        }

        .card-group .card:first-child {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        .card-group .card {
            margin-bottom: 0;
            -webkit-box-flex: 1;
            -webkit-flex: 1 0 0%;
            -ms-flex: 1 0 0%;
            flex: 1 0 0%;
        }
    }

    .counter {
        text-align: center;
    }

    .vertical-align:before {
        display: inline-block;
        height: 100%;
        vertical-align: middle;
        content: "";
    }

    .vertical-align-bottom,
    .vertical-align-middle {
        display: inline-block;
        max-width: 100%;
        font-size: 1rem;
    }

    .vertical-align-middle {
        vertical-align: middle;
    }

    .counter-lg .counter-icon {
        font-size: 40px;
    }

    .counter-inverse .counter-icon {
        color: #00448b;
    }

    .counter-inverse {
        color: #303031;
    }

    .h-150 {
        height: 150px !important;
    }

    .modal-qr-block {
        width: 100%;
        position: relative;
        display: block;
        padding: 20px 10px 0px;
        text-align: center;
    }

    .modal-passport-block {
        width: 100%;
        position: relative;
        display: block;
        padding: 5px 10px 0px;
    }

    .option__image {
        max-height: 80px;
        margin-right: 10px
    }

    .option__desc,
    .option__image {
        display: inline-block;
        vertical-align: middle
    }

    .option__desc {
        padding: rem(10px)
    }

    .option__title {
        font-size: rem(24px)
    }

    .option__small {
        margin-top: rem(10px);
        display: block
    }

    .form__label {
        margin-top: 5px !important
    }

    .badge__img {
        vertical-align: middle;
        float: right
    }

    .badge__name {
        vertical-align: middle;
        display: inline-block;
        margin-left: 5px;
        float: left
    }

    .products-section {
        text-align: left;
        padding-top: 0px;
        padding-bottom: 20px;
    }

    .employeeheader {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        min-height: 40px;
        height: 100%;
        position: relative;
        background: #FFFFFF;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .employeeheader>.descriptionheader {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 16px 25px;
        border-bottom: 1px solid transparent;
    }

    .employeeheader>.descriptionheader .description-text-header-left h5 {
        font-size: 16px;
        font-weight: 600;
        margin: 0;
        color: #00448b;
    }

    .employeeheader>.descriptionheader .description-text-header-right {
        font-size: 13px;
        margin-left: auto;
        padding-left: 12px;
        color: #4e5764;
        font-weight: 500;
    }

    .employeeheader>.descriptionheader .description-text-header-right {
        display: block;
        margin-top: 30px;
    }

    .products-section {
        font-weight: bold;
        line-height: 1.22;
        color: #303031;
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .see-link {
        text-decoration: underline;
        font-size: 13px;
        font-weight: normal;
        line-height: 1.2;
        color: #00448b;
        cursor: pointer;
        float: right;
    }

    .btn-outline-danger:hover {
        color: #fff !important;
        background-color: #F44336;
        border-color: #F44336;
    }

    .btn-outline-danger {
        color: #F44336 !important;
        background-color: transparent;
        background-image: none;
        border-color: #F44336;
    }

    .btn-secondary.btn-outline {
        color: #00448b !important;
        background-color: transparent;
        background-image: none;
        border: 1px solid #00448b;
    }

    .btn-secondary.btn-outline:hover {
        color: #fff !important;
        background-color: #00448b;
        border-color: #00448b;
    }

    .btn-outline-default:hover {
        color: #fff !important;
        background-color: #4e5764;
        border-color: #4e5764;
    }

    .btn-outline-default {
        color: #4e5764 !important;
        background-color: transparent;
        background-image: none;
        border-color: #4e5764;
    }

    .nav-pills.nav-employees .nav-link.active,
    .nav-pills.nav-employees .show>.nav-link {
        color: #fff;
        background-color: #00448b;
    }

    .nav-pills.nav-employees .nav-link {
        -webkit-border-radius: 18px;
        border-radius: 18px;
    }

    .nav-pills.nav-employees .nav-link {
        height: 32px;
        color: #00448b;
        text-decoration: none;
        border: 1px solid #00448b;
        line-height: 32px;
        margin-right: 10px;
    }

    .nav-pills.nav-employees .nav-link:hover,
    .nav-pills.nav-employees .nav-link:focus {
        text-decoration: none;
        color: #fff !important;
        background-color: #00448b;
    }

    .tab-content.employee-tab-content {
        padding: 10px 0px;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.two-line {
        border-radius: 6px;
        background-color: transparent;
        min-height: 7.8rem !important;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.two-line>.avatar {
        -webkit-border-radius: 0px !important;
        border-radius: 0px !important
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.two-line>.avatar i {
        font-size: 40px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        color: #00448b;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.two-line>.secondary-container {
        margin-top: 0px;
        margin-right: -5px;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.two-line>.secondary-container i {
        font-size: 20px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        color: #00448b;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.two-line>.secondary-container .el-dropdown {}

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.two-line>.secondary-container .el-dropdown .el-dropdown-link {
        cursor: pointer;
        color: #00448b;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.two-line>.secondary-container .el-dropdown .el-dropdown-link .el-icon-arrow-down {
        font-size: 20px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        color: #00448b;
    }

    .mediaprodadmin .media-right .el-dropdown {
        color: #fff;
    }

    .mediaprodadmin .media-right .el-dropdown .el-dropdown-link i {
        color: #fff;
        cursor: pointer;
        font-size: 20px;
        width: 16px;
        height: 16px;
        line-height: 16px;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.two-line h3 {
        font-size: 14px;
        margin: 5px 0px 5px;
        line-height: 1.21;
        font-weight: bold;
        color: #303031;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.two-line p {
        font-size: 13px;
        font-weight: 500;
        letter-spacing: 0.01em;
        margin: 6px 0px 0px;
        color: #1a9347;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.three-line {
        min-height: 10.8rem;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.three-line h3 {
        font-size: 14px;
        margin: 5px 0px 5px;
        line-height: 1.21;
        font-weight: bold;
        color: #303031;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.three-line h4 {
        font-size: 14px;
        font-weight: 400;
        line-height: 0.93;
        letter-spacing: 0.6px;
        margin: 1px 0 1px 0;
        color: #4e5764;
        height: 24px;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.three-line p {
        font-size: 1.3rem;
        font-weight: 500;
        letter-spacing: 0.01em;
        margin: 6px 0px 0px;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.three-line p button {
        margin: 0;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.three-line>.secondary-container {
        margin-top: 0px;
        margin-right: -5px;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.three-line>.secondary-container i {
        font-size: 20px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        color: #00448b;
    }

    .md-card.adminproducts-card .md-card-head .list-group .list-group-item.three-line>.avatar {
        margin-top: 1.4rem;
    }

    .el-dropdown-menu__item {
        list-style: none;
        line-height: 36px;
        padding: 0 20px;
        margin: 0;
        font-size: 14px;
        color: #303031;
        cursor: pointer;
        outline: none;
    }

    .productspageHeader {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        min-height: 40px;
        position: relative;
        background: transparent;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 4px;
    }

    .productspageHeader>.descriptionheader {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 8px 14px;
        border-bottom: 1px solid transparent;
    }

    .productspageHeader>.descriptionheader .description-text-header-left h5 {
        font-size: 15px;
        font-weight: 600;
        margin: 0;
        color: #00448b;
    }

    .productspageHeader>.descriptionheader .description-text-header-right {
        font-size: 13px;
        margin-left: auto;
        padding-left: 12px;
        color: #00448b;
        font-weight: 500;
    }

    .productspageHeader>.descriptionheader .description-text-header-right {
        display: block;
    }

    .productspageHeader>.descriptionheader .description-text-header-right i {
        color: #00448b;
        font-size: 16px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        cursor: pointer;
    }

    /* .md-card.adminproducts-card .md-card-head .list-group .list-group-item>.avatar i.logo-crm {
    font-size: 25px !important;
}
.md-card.adminproducts-card .md-card-head .list-group .list-group-item>.avatar i.logo-cloud {
    font-size: 25px !important;
} */
</style>


// WEBPACK FOOTER //
// src/components/AdminProducts.vue